import SweetAlertBS from "react-bootstrap-sweetalert";
import styled, { css } from "styled-components";

interface IContainer {
  isProductBundleScreen: boolean;
  isCourseLandingPageFooter: boolean;
  themeBuyButtonsOption: string;
  customButtonColor: string;
  isCourseLandingPageCard: boolean;
}

export const SweetAlert = styled(SweetAlertBS)`
  h2 {
    font-size: 332px;
  }

  div {
    background-color: ${({ theme }) =>
      theme.colors?.modalBackgroundColor} !important;
  }
`;

export const Container = styled.div<IContainer>`
  z-index: 1;
  width: 100%;
  display: flex;
  overflow: visible;
  position: relative;
  justify-content: center;

  .text-plus-btn-container {
    max-width: 25rem;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    ${(props) =>
      props.isCourseLandingPageCard &&
      css`
        padding: 0px 32px 0;
      `}

    h3,
    h4 {
      text-align: center;
    }

    p {
      font-size: 15px;
    }

    button {
      margin: 0;
      width: 100%;
    }

    ${({ isProductBundleScreen }) =>
      isProductBundleScreen &&
      css`
        button {
          margin-top: 15px;
        }
      `}

    .buy-btn {
      color: ${({ theme }) => theme.colors.btnTextColor} !important;

      &:hover {
        opacity: 0.8;
        color: ${({ theme }) => theme.colors.btnTextColor} !important;
      }
    }
  }

  h5 {
    color: ${({ theme }) => theme.colors.textColor};
  }

  ${({ themeBuyButtonsOption }) =>
    themeBuyButtonsOption !== "automatic" &&
    css<IContainer>`
      .buy-btn {
        background-color: ${({ customButtonColor }) =>
          customButtonColor} !important;
        border-color: ${({ customButtonColor }) =>
          customButtonColor} !important;
        color: ${({ theme }) => theme.colors.btnTextColor} !important;

        &:hover {
          opacity: 0.8;
          color: ${({ theme }) => theme.colors.btnTextColor} !important;
        }
      }
    `}

  ${({ isCourseLandingPageFooter }) =>
    !isCourseLandingPageFooter
      ? css`
          .buy-btn {
            height: 48px;
            font-size: 1rem;
            font-weight: bold;
            margin-top: 2rem;
            color: ${({ theme }) => theme.colors.btnTextColor} !important;

            &:hover {
              opacity: 0.8;
              color: ${({ theme }) => theme.colors.btnTextColor} !important;
            }
          }

          .buy-btn.buy-or-subscribe {
            margin-top: 1rem;
            color: ${({ theme }) => theme.colors.btnTextColor} !important;

            &:hover {
              opacity: 0.8;
              color: ${({ theme }) => theme.colors.btnTextColor} !important;
            }
          }
        `
      : css`
          .buy-btn {
            width: 220px;
            max-width: 220px;
            color: ${({ theme }) => theme.colors.btnTextColor} !important;

            &:hover {
              opacity: 0.8;
              color: ${({ theme }) => theme.colors.btnTextColor} !important;
            }
          }
        `}
`;
